import { render, staticRenderFns } from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=template&id=60626580&scoped=true&"
import script from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=style&index=0&id=60626580&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60626580",
  null
  
)

export default component.exports